import {ISchoolService} from './ISchoolService';
import {SchoolRepository} from './SchoolRepository';
import {
  AssetInsert,
  ClassesConnection,
  School,
  SchoolInsert,
  SchoolsConnection,
} from '../../graphql/API';
import {AssetsService} from '../Asset';

export class SchoolService implements ISchoolService {
  schoolRepository: SchoolRepository;
  assetsService: AssetsService;
  constructor() {
    this.schoolRepository = new SchoolRepository();
    this.assetsService = new AssetsService();
  }
  async signUpSchool(email: string, password: string): Promise<any> {
    return await this.schoolRepository.signUpSchool(email, password);
  }

  async getSchools(
    nextToken: string,
    searchValue?: string,
  ): Promise<SchoolsConnection> {
    return await this.schoolRepository.getSchools(nextToken, searchValue);
  }

  async getSchoolById(id: string): Promise<School> {
    return await this.schoolRepository.getSchoolById(id);
  }

  async getClassesBySchoolId(schoolId: string): Promise<ClassesConnection> {
    return await this.schoolRepository.getClassesBySchoolId(schoolId);
  }
  async createTeacher(
    teacherUserId: string,
    email: string,
    name: string,
    phoneNumber: string,
    schoolId: string,
  ): Promise<ClassesConnection> {
    return await this.schoolRepository.createTeacher(
      teacherUserId,
      email,
      name,
      phoneNumber,
      schoolId,
    );
  }
  async createClassSchool(
    schoolId: string,
    teacherId: string,
    name: string,
    schoolYear: string,
    levelId: string,
  ): Promise<any> {
    return await this.schoolRepository.createClassSchool(
      schoolId,
      teacherId,
      name,
      schoolYear,
      levelId,
    );
  }
  async activateSubsctiptionInClass(
    classschoolId: string,
    discountcodeId: string,
    packageId: string,
  ): Promise<string> {
    return await this.schoolRepository.activateSubsctiptionInClass(
      classschoolId,
      discountcodeId,
      packageId,
    );
  }

  async createSchool(
    schoolInput: SchoolInsert,
    promoInsert: AssetInsert,
  ): Promise<any> {
    try {
      schoolInput.promoId = await this.assetsService.createAsset(promoInsert);
    } catch (e: any) {
      alert(`Error in uploading school logo:${e}`);
    }
    return await this.schoolRepository.createSchool(schoolInput);
  }

  async createUser(
    cognitoUserId: string,
    country: string,
    whatsappNumber: string,
    timestamp: string,
  ): Promise<any> {
    let user = await this.schoolRepository.createUser(
      cognitoUserId,
      country,
      whatsappNumber,
      timestamp,
    );
    return user;
  }

  async getClassSchoolById(classschoolId: string): Promise<any> {
    return await this.schoolRepository.getClassSchool(classschoolId);
  }

  async getClassSchoolWithStudentsEnrollments(
    classschoolId: string,
  ): Promise<any> {
    return await this.schoolRepository.getClassSchoolWithStudentsEnrollments(
      classschoolId,
    );
  }
}
